export default "__VITE_ASSET__CaTA9n5A__"